/**
 * What a missing value shows as, in tables, cards and CSV-free text alike. `@/lib/formatters`
 * re-exports it; import it from here only in plain logic modules whose tests can't load the
 * formatters (they read the current project's settings).
 */
export const EMPTY = '—';
